export enum TransferScanModal {
  GAYLORD_NOT_FOUND = "GAYLORD_NOT_FOUND",
  GAYLORD_NOT_ELIGIBLE = "GAYLORD_NOT_ELIGIBLE",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
